interface SliderItem {
  src: string;
  label: string;
}

export const sliderData: SliderItem[] = [
  {
    src: 'slider-1.webp',
    label: 'Aparna Western Meadows',
  },
  {
    src: 'slider-2.webp',
    label: 'Children Play',
  },
  {
    src: 'slider-3.webp',
    label: 'Sitout & relaxing area',
  },
  {
    src: 'slider-4_1.webp',
    label: 'Seating area',
  },
  {
    src: 'slider-5.webp',
    label: 'Gazebo',
  },
  {
    src: 'slider-6_1.webp',
    label: 'Gazebo in Phase 4',
  },
  {
    src: 'slider-7.webp',
    label: 'Gate 1 Entrance',
  },
  {
    src: 'slider-8.webp',
    label: 'Phase 4',
  },
];
